.state {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
  max-width: 560px;
  padding: var(--space-10) var(--space-5);
}

.centered {
  align-items: center;
  margin-inline: auto;
  text-align: center;
}

.compact {
  gap: var(--space-3);
  padding: var(--space-8) var(--space-4);
}

.iconWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-lg);
  background: var(--color-layer-1);
}

.iconWrap svg {
  fill: var(--color-icon-secondary);
}

.compact .iconWrap {
  width: 44px;
  height: 44px;
}

/* Пустое состояние — одна строка серым и одно действие, без картинки (DESIGN.md 1.5); иконка остаётся у ошибок и предупреждений. */
.state:not(.toneError):not(.toneWarning) .iconWrap {
  display: none;
}

.toneError .iconWrap {
  background: var(--color-error-bg);
}

.toneError .iconWrap svg {
  fill: var(--color-error-icon);
}

.toneWarning .iconWrap {
  background: var(--color-warning-bg);
}

.toneWarning .iconWrap svg {
  fill: var(--color-warning);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.title {
  font-size: var(--type-heading-md-size);
  line-height: var(--type-heading-md-line);
  font-weight: var(--weight-semibold);
  text-wrap: balance;
}

.state:not(.toneError):not(.toneWarning) .title {
  font-size: var(--type-body-size);
  line-height: var(--type-body-line);
  font-weight: var(--weight-medium);
}

.compact .title {
  font-size: var(--type-heading-sm-size);
  line-height: var(--type-heading-sm-line);
}

.description {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  text-wrap: pretty;
}

.compact .description {
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-inline-start: var(--space-5);
  list-style: disc;
  color: var(--color-text-secondary);
  text-align: start;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.centered .actions {
  justify-content: center;
}

.meta {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
}

.code {
  font-family: var(--font-mono);
  letter-spacing: 0;
  color: var(--color-text-secondary);
}

.copy {
  padding: 0;
  border: 0;
  background: none;
  color: var(--color-link);
  font-size: inherit;
  text-decoration: underline;
  text-underline-offset: 0.18em;
}
